import React, {useEffect, useState} from 'react';

import CanvasJSChart from "./CanvasJSChart";
import SpinnerDiv from "root/Components/SpinnerDiv";

import { getPanelHeader } from "./DashboardPanelFunctions";
import {getDataFromResponse, getNumRowsFromResponse} from "root/DataFunctions/BaseDataFns";
import {getMessagesForOrg} from "root/DataFunctions/DashboardDataFns";
import {MessageType} from "root/DataFunctions/Constants";
import {dashboardDefaults, defaultTitleFontSize} from "root/dashboard/DashboardDefault";
import {useGlobalContext} from "root/contexts/GlobalContext";

const DashboardPanelOrgMessages = (props) =>
{
	const [ data, setData ] = useState ({ loading: true, data: []}) ;

	const { user_org } = useGlobalContext() ;

	useEffect(() =>
	{
		getServerData() ;
	}, [props.user_type, props.month]);

    const generateDataPoints = ( items ) =>
	{
		return items.map ((item) =>
			{
				return ({
					label: item.fullName,
					y: Number(item.count),
					tool: item.count
				})
			}
		)
	}

	const getServerData = () => {

		getMessagesForOrg( props.user_type, user_org, props.month, props.year, MessageType.MESSAGE_TYPE_MESSAGE, (response) =>
		{
			const recs = getDataFromResponse(response);

			setData ( { loading: false, data : recs}) ;
		});
	};

	const formPanel = () =>
	{
		const options = {
			maintainAspectRatio: false,
			responsive: true,
			animationEnabled: true,
			height: props.height,
			...dashboardDefaults,
			title: {
				text: props.title,
				fontSize: defaultTitleFontSize
			},
			data: [
				{
					type: 'column',
					lineColor: 'red',
					indexLabelPlacement: 'inside',    //Try Changing to outside
					showInLegend: true,
					legendMarkerColor: 'grey',
					legendText: 'Number of Messages',
					toolTipContent: '{tool}',
					dataPoints: generateDataPoints(data.data)
				}
			] } ;

		return (
			<div className={'panel ' + props.panelStyle}>
				{ getPanelHeader({ title: '' })}
				<div className='panel-body'>
					<CanvasJSChart id='messages' options={options} uniqueId='messages' />
				</div>
			</div>
		)
	}

	return data.loading === true ? <SpinnerDiv/> : formPanel() ;
}

export default DashboardPanelOrgMessages;

DashboardPanelOrgMessages.defaultProps =
{
	title: 'title',
	height: 500,
	panelStyle: 'panel-default',
}